import instaclustrComponent from "./Components";

export class Component extends instaclustrComponent {
    constructor(name, node) {
        super(name, node);
    }
    init() {
        console.log(this.name);

        // Breakpoint references
        let sm = 576,
            md = 768,
            lg = 992,
            xl = 1200;

        // Viewport width helper function
        function viewport() {
            let e = window,
                a = 'inner';
            if (!('innerWidth' in window)) {
                a = 'client';
                e = document.documentElement || document.body;
            }
            return { width: e[ a + 'Width' ], height : e[ a + 'Height'] };
        }

        let vpWidth       = viewport().width;

        // Tabby.min.js documentation:
        // https://github.com/cferdinandi/tabby

        // Get all tabbed content components
        let $tabs  = jQuery('.component-tabbed-content-2024');
        let $tabDataId = $tabs.attr('data-js-tabs');
        let tabComponent;

        // Init Tabby
        if (vpWidth > sm) {

            // Init Tabby
            if ($tabs.length > 0) {
                tabComponent = new Tabby(`[data-tabs-` + $tabDataId + `]`);
            }

            // Set up animation behavior on click
            let $tabElements     = jQuery('.component.component-tabbed-content-2024 li.tab-title');
            let $tabDescriptions = jQuery('ul.tabs-descriptions');
            let $tabDescFirst    = $('#description-' + $tabDataId + '-1');

            $tabElements.each(function(index) {
                jQuery(this).click(function() {
                    let $tabId = $(this).attr('id');
                    let $tabNumber= Number($tabId);
                    $tabElements.removeClass('animate');
                    $tabElements.removeClass('animate-click');
                    $(this).addClass('animate-click');
                    showDescription($tabNumber);
                });
            });

            // Set up descriptions to appear with tabs
            function showDescription(number) {
                if (vpWidth > lg) {
                    $tabDescriptions.find('li').css('visibility', 'hidden');
                    $tabDescriptions.find('#description-' + $tabDataId + '-' + number).css('visibility', 'visible');
                } else {
                    $tabDescriptions.find('li').hide();
                    $tabDescriptions.find('#description-' + $tabDataId + '-' + number).show();
                }
            }

            // Show first description on page load
            showDescription(1);

            // Reset tabs to 1
            function resetTabs() {
                tabComponent.toggle('#panel-'+ $tabDataId + '-' + '1');
                $tabElements.each(function(index) {
                    $(this).removeClass('animate');
                    $(this).removeClass('animate-click');
                });
                showDescription(1);
            }

            function pauseTabs(state) {
                if (state) {
                    $tabElements.each(function() {
                        $(this).addClass('paused');
                        $(this).removeClass('animate');
                        $(this).removeClass('animate-click');
                    });
                } else {
                    $tabElements.each(function() {
                        $(this).removeClass('paused');
                    });
                }
            }

            function restartAnimations() {
                $tabElements.each(function(index) {
                    $(this).removeClass('animate');
                    $(this).removeClass('animate-click');
                    tabComponent.toggle('#panel-'+ $tabDataId + '-' + '1');
                    if (index === 0) {
                        $(this).addClass('animate');
                    }
                });
            }

            // Activate tabs in sequence as animations end
            // TODO: make this work with multiple Tabbys on a page
            $tabElements.on('animationend', function(e) {
                let $current   = jQuery(this);
                let $next      = $current.next('li');
                let $tabId     = $current.attr('id');
                let $tabNumber= Number($tabId);
                $tabNumber++; // next tab
                $next.addClass('animate');
                tabComponent.toggle('#panel-' + $tabDataId + '-' + $tabNumber);
                showDescription($tabNumber);
                // Reset if at the end
                if (!$('#panel-' + $tabDataId + '-' + $tabNumber).length) {
                    resetTabs();
                    restartAnimations();
                }
            });

            // Create intersection observer to watch for when component is in view
            const intersectionCallback = (entries) => {
                for (const entry of entries) { // Loop over all elements that either enter or exit the view.
                    if (entry.isIntersecting) { // This is true when the element is in view
                        pauseTabs(false);
                        restartAnimations();
                    } else {
                        //resetTabs();
                        pauseTabs(true);
                    }
                }
            }

            const observer = new IntersectionObserver(intersectionCallback);

            const items = document.querySelectorAll('ul.tabs-nav.tab-anchors');
            for (const item of items) {
                observer.observe(item);
            }
        }
    }
}